import script from "./AgentMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentMessage.vue?vue&type=script&setup=true&lang=js"

import "./AgentMessage.vue?vue&type=style&index=0&id=a2266a18&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2266a18"]])

export default __exports__